import React from "react";
import Lottie from "lottie-react";
import accessDeniedAnimation from "helpers/constants/access-denied-lottie.json";

function AccessDeniedAnimation() {
  const lottieRef = React.useRef<any>(null);
  React.useEffect(() => {
    lottieRef.current?.setSpeed(0.7);
  }, []);
  return (
    <div
      style={{
        width: "145px",
        height: "145px",
      }}
      className="mx-auto bg-[#EFF1FF] rounded-full items-center "
      data-testid="access-denied-animation"
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={accessDeniedAnimation}
        loop={true}
        autoplay={true}
        // speed="0.1"
        style={{
          width: "110px",
          height: "110px",
          margin: "20px",
        }}
      />
    </div>
  );
}
export default AccessDeniedAnimation;
